/**
 * @generated SignedSource<<94c5baa1a908e64fbd0d7ae8acaed8f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobLocationTypeEnum = "anywhere" | "full_address" | "job_timezone" | "specific_countries";
export type Position = "freelancer" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type JobHead_Job$data = {
  readonly availabilityType: string | null | undefined;
  readonly city: string | null | undefined;
  readonly country: string | null | undefined;
  readonly createdAt: string | null | undefined;
  readonly currency: {
    readonly code: string | null | undefined;
  } | null | undefined;
  readonly description: string | null | undefined;
  readonly firm: {
    readonly logoUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly website: string | null | undefined;
  } | null | undefined;
  readonly freelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly fullAddress: string | null | undefined;
  readonly locationType: JobLocationTypeEnum | null | undefined;
  readonly minFreelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly positionTypes: ReadonlyArray<Position>;
  readonly rateMode: RateMode | null | undefined;
  readonly region: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "JobHead_Job";
};
export type JobHead_Job$key = {
  readonly " $data"?: JobHead_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobHead_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobHead_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availabilityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Currency",
      "kind": "LinkedField",
      "name": "currency",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minFreelancerRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "freelancerRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "region",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "831815c3440f24cfffef7b0eea88942e";

export default node;
